module.exports = __webpack_public_path__ + "static/media/faq-uuid.24b84e69.svg";